import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var header = /*#__PURE__*/css(["display:flex;margin:", ";padding-bottom:", ";margin-top:", ";justify-content:center;", ""], stack(spacing.lg), pxToRem(spacing.sm), pxToRem(10), mediaQuery({
  min: minBreakpoints.L
}, css(["margin:", ";padding-bottom:", ";"], stack(spacing.xl), pxToRem(spacing.md))));
export var carousel = /*#__PURE__*/css(["overflow:hidden;margin-bottom:", ";margin-top:", ";", ""], pxToRem(14), pxToRem(-6), mediaQuery({
  min: minBreakpoints.M,
  max: maxBreakpoints.M
}, css(["margin-bottom:", ";"], pxToRem(spacing.md))));